import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import GuestRoute from '../router/GuestRoute';
import ProtectedRoute from '../router/ProtectedRoute';
import AuthLayout from '../layouts/AuthLayout';
import AdminLayout from '../layouts/AdminLayout';
import LoginPage from '../pages/auth/LoginPage';
import DashboardPage from '../pages/DashboardPage';
import PlaceholderPage from '../pages/PlaceholderPage';
import MemberListPage from '../pages/members/MemberListPage';
import BalanceAdjustPage from '../pages/finance/BalanceAdjustPage';
import TransactionListPage from '../pages/finance/TransactionListPage';
import DepositListPage from '../pages/deposits/DepositListPage';
import OnlineDepositListPage from '../pages/deposits/OnlineDepositListPage';
import DepositWithdrawalParamSettingPage from '../pages/payment/DepositWithdrawalParamSettingPage';
import CoinManagePage from '../pages/payment/CoinManagePage';
import OnlineMerchantPage from '../pages/payment/OnlineMerchantPage';
import OnlinePaymentChannelPage from '../pages/payment/OnlinePaymentChannelPage';
import OfflineMerchantPage from '../pages/payment/OfflineMerchantPage';
import WalletAddressManagePage from '../pages/payment/WalletAddressManagePage';
import WithdrawListPage from '../pages/withdrawals/WithdrawListPage';
import FuturesRoundsPage from '../pages/futures/FuturesRoundsPage';
import FuturesOrdersPage from '../pages/futures/FuturesOrdersPage';
import FollowOrdersPage from '../pages/futures/FollowOrdersPage';
import FollowCustomizeMembersPage from '../pages/futures/FollowCustomizeMembersPage';
import OrderProductListPage from '../pages/products/OrderProductListPage';
import TimedOrdersPage from '../pages/timed/TimedOrdersPage';
import PerpetualOrdersPage from '../pages/perpetual/PerpetualOrdersPage';
import PerpetualEntrustmentsPage from '../pages/perpetual/PerpetualEntrustmentsPage';
import OrderControlSpecificUserPage from '../pages/order-control/OrderControlSpecificUserPage';
import OrderControlGlobalPage from '../pages/order-control/OrderControlGlobalPage';
import KycIdentityVerificationPage from '../pages/kyc/KycIdentityVerificationPage';
import MemberWithdrawAddressListPage from '../pages/members/MemberWithdrawAddressListPage';
import RoleManagePage from '../pages/auth-manage/RoleManagePage';
import PeopleManagePage from '../pages/auth-manage/PeopleManagePage';
import GoogleCaptchaPage from '../pages/auth-manage/GoogleCaptchaPage';
import NewsInfoPage from '../pages/content/NewsInfoPage';
import FrontConfigPage from '../pages/front-config/FrontConfigPage';
import VerificationCodeManagePage from '../pages/verify-code/VerificationCodeManagePage';
import SystemDicSettingPage from '../pages/system-dic/SystemDicSettingPage';
import OperationLogPage from '../pages/operation-log/OperationLogPage';
import SmsManagePage from '../pages/sms-manage/SmsManagePage';
import CarouselPage from '../pages/carousel/CarouselPage';
import MarqueePage from '../pages/marquee/MarqueePage';
import PopAnnouncementPage from '../pages/pop-announcement/PopAnnouncementPage';
import AnnouncementCenterPage from '../pages/announcement-center/AnnouncementCenterPage';
import SiteMessagePage from '../pages/site-message/SiteMessagePage';
import HelpCenterPage from '../pages/help-center/HelpCenterPage';
import AboutUsPage from '../pages/about-us/AboutUsPage';
import UserAgreementPage from '../pages/user-agreement/UserAgreementPage';
import PrivacyPolicyPage from '../pages/privacy-policy/PrivacyPolicyPage';
import BeginnerGuidePage from '../pages/beginner-guide/BeginnerGuidePage';
import CustomerCenterTypePage from '../pages/customer-center-type/CustomerCenterTypePage';
import CustomerCenterManagementPage from '../pages/customer-center-management/CustomerCenterManagementPage';
import StickerPackPage from '../pages/im-sticker/StickerPackPage';
import StickerAssetPage from '../pages/im-sticker/StickerAssetPage';
import GifPackPage from '../pages/im-gif/GifPackPage';
import GifAssetPage from '../pages/im-gif/GifAssetPage';
import ReactionPackPage from '../pages/im-reaction/ReactionPackPage';
import ReactionEmojiPage from '../pages/im-reaction/ReactionEmojiPage';
import ImReportPage from '../pages/im-report/ImReportPage';
import CsWorkbenchPage from '../pages/im-customer-service/CsWorkbenchPage';
import CsSupervisorPage from '../pages/im-customer-service/CsSupervisorPage';
import ImFeatureSwitchPage from '../pages/im-customer-service/ImFeatureSwitchPage';
import UserStatisticsReportPage from '../pages/statistical-report/UserStatisticsReportPage';
import AgencyStatisticsReportPage from '../pages/statistical-report/AgencyStatisticsReportPage';
import PersonalDataReportPage from '../pages/statistical-report/PersonalDataReportPage';
import ImCsReportPage from '../pages/statistical-report/ImCsReportPage';
import ImChatReportPage from '../pages/statistical-report/ImChatReportPage';
import GroupTripListPage from '../pages/travel-manage/GroupTripListPage';
import TradeListPage from '../pages/travel-manage/TradeListPage';
import SafetyReportsPage from '../pages/travel-manage/SafetyReportsPage';
import AdsReviewPage from '../pages/travel-manage/AdsReviewPage';
import AdsCampaignOpsPage from '../pages/travel-manage/AdsCampaignOpsPage';
import CustomLocationReviewPage from '../pages/travel-manage/CustomLocationReviewPage';
import AdsEntryRedirect from '../pages/ads/AdsEntryRedirect';
import AdsLegacyRedirect from '../pages/ads/AdsLegacyRedirect';
import {
  ADS_CANONICAL_CAMPAIGNS,
  ADS_CANONICAL_REVIEW,
  ADS_ENTRY_PATH,
  ADS_LEGACY_CAMPAIGNS,
  ADS_LEGACY_REVIEW,
} from '../pages/ads/adsNavigation';
import { MENU_PAGE_PATHS } from '../config/menuPaths';

/** 已實作頁面對照（其餘路徑顯示 PlaceholderPage）；export 供 binding 測試驗證非 placeholder */
export const PAGE_COMPONENTS = {
  '/system/auth-manage/role-manage': RoleManagePage,
  '/system/auth-manage/people-manage': PeopleManagePage,
  '/system/auth-manage/google-captcha': GoogleCaptchaPage,
  '/system/content-manage/news-info': NewsInfoPage,
  '/system/content-manage/carousel': CarouselPage,
  '/system/content-manage/marquee': MarqueePage,
  '/system/content-manage/pop-up-announcement': PopAnnouncementPage,
  '/system/content-manage/announcement-center': AnnouncementCenterPage,
  '/system/content-manage/site-message': SiteMessagePage,
  '/system/content-manage/help-center': HelpCenterPage,
  '/system/content-manage/about-us': AboutUsPage,
  '/system/content-manage/user-agreement': UserAgreementPage,
  '/system/content-manage/privacy-policy': PrivacyPolicyPage,
  '/system/content-manage/beginner-guide': BeginnerGuidePage,
  '/system/content-manage/customer-center-type': CustomerCenterTypePage,
  '/system/content-manage/customer-center-management': CustomerCenterManagementPage,
  '/system/sticker-manage/pack': StickerPackPage,
  '/system/sticker-manage/gif': GifPackPage,
  '/system/sticker-manage/reaction': ReactionPackPage,
  '/system/im-moderation/reports': ImReportPage,
  '/system/im-customer-service/feature-switch': ImFeatureSwitchPage,
  '/system/im-customer-service/workbench': CsWorkbenchPage,
  '/system/im-customer-service/supervisor': CsSupervisorPage,
  '/system/statistical-report/user-statistics-report': UserStatisticsReportPage,
  '/system/statistical-report/agency-statistics-report': AgencyStatisticsReportPage,
  '/system/statistical-report/personal-data-report': PersonalDataReportPage,
  '/system/statistical-report/im-cs-report': ImCsReportPage,
  '/system/statistical-report/im-chat-report': ImChatReportPage,
  '/system/system-manage/front-config': FrontConfigPage,
  '/system/system-manage/verification-code-manage': VerificationCodeManagePage,
  '/system/system-manage/system-dic-setting': SystemDicSettingPage,
  '/system/system-manage/operation-log': OperationLogPage,
  '/system/system-manage/sms-manage': SmsManagePage,
  '/system/user-manage/user-list': MemberListPage,
  '/system/user-manage/kyc-identity-verification': KycIdentityVerificationPage,
  '/system/user-manage/user-withdraw-address-list': MemberWithdrawAddressListPage,
  '/system/user-manage/balance-adjust': BalanceAdjustPage,
  '/system/capital-flow/transaction-flow': TransactionListPage,
  '/system/capital-flow/recharge-list': DepositListPage,
  '/system/capital-flow/online-recharge-list': OnlineDepositListPage,
  '/system/payment-manage/deposit-withdrawal-param-setting': DepositWithdrawalParamSettingPage,
  '/system/payment-manage/coin-manage': CoinManagePage,
  '/system/payment-manage/payment-manage-online-merchant': OnlineMerchantPage,
  '/system/payment-manage/payment-manage-online-payment-channel': OnlinePaymentChannelPage,
  '/system/payment-manage/payment-recharge-manage': OfflineMerchantPage,
  '/system/payment-manage/wallet-address-manage': WalletAddressManagePage,
  '/system/capital-flow/withdrawal-list': WithdrawListPage,
  '/system/fast-contract-manage/fast-contract-cycle-record': FuturesRoundsPage,
  '/system/fast-contract-manage/fast-contract-order': FuturesOrdersPage,
  '/system/fast-contract-manage/follow-order': FollowOrdersPage,
  '/system/fast-contract-manage/follow-customize-members': FollowCustomizeMembersPage,
  '/system/product-manage/product-list': OrderProductListPage,
  '/system/product-manage/control-specific-user': OrderControlSpecificUserPage,
  '/system/product-manage/control-global': OrderControlGlobalPage,
  '/system/limit-trade/limit-trade-historical-order': TimedOrdersPage,
  '/system/perpetual-contract/perpetual-contract-order': PerpetualOrdersPage,
  '/system/perpetual-contract/perpetual-contract-entrustment': PerpetualEntrustmentsPage,
  '/system/travel-manage/group-trip-list': GroupTripListPage,
  '/system/travel-manage/trade-list': TradeListPage,
  '/system/travel-manage/safety-reports': SafetyReportsPage,
  '/system/travel-manage/custom-location-review': CustomLocationReviewPage,
  [ADS_CANONICAL_REVIEW]: AdsReviewPage,
  [ADS_CANONICAL_CAMPAIGNS]: AdsCampaignOpsPage,
};

const LEGACY_REDIRECTS = [
  ['/members', '/system/user-manage/user-list'],
  ['/finance/transactions', '/system/capital-flow/transaction-flow'],
  ['/deposits', '/system/capital-flow/recharge-list'],
  ['/withdrawals', '/system/capital-flow/withdrawal-list'],
  ['/futures/rounds', '/system/fast-contract-manage/fast-contract-cycle-record'],
  ['/finance/adjust', '/system/user-manage/balance-adjust'],
];

/** React Router v7 升級預先啟用，避免開發環境 deprecation 警告 */
const ROUTER_FUTURE = {
  v7_startTransition: true,
  v7_relativeSplatPath: true,
};

export default function AppRouter() {
  return (
    <BrowserRouter future={ROUTER_FUTURE}>
      <Routes>
        <Route element={<GuestRoute />}>
          <Route element={<AuthLayout />}>
            <Route path="/login" element={<LoginPage />} />
          </Route>
        </Route>

        <Route element={<ProtectedRoute />}>
          <Route element={<AdminLayout />}>
            <Route path="/" element={<DashboardPage />} />

            {MENU_PAGE_PATHS.map((path) => {
              const Page = PAGE_COMPONENTS[path] || PlaceholderPage;
              return <Route key={path} path={path} element={<Page />} />;
            })}

            <Route path={ADS_ENTRY_PATH} element={<AdsEntryRedirect />} />
            <Route
              path={ADS_LEGACY_REVIEW}
              element={<AdsLegacyRedirect from={ADS_LEGACY_REVIEW} />}
            />
            <Route
              path={ADS_LEGACY_CAMPAIGNS}
              element={<AdsLegacyRedirect from={ADS_LEGACY_CAMPAIGNS} />}
            />

            <Route
              path="/system/sticker-manage/pack/assets"
              element={<StickerAssetPage />}
            />
            <Route
              path="/system/sticker-manage/gif/assets"
              element={<GifAssetPage />}
            />
            <Route
              path="/system/sticker-manage/reaction/emojis"
              element={<ReactionEmojiPage />}
            />

            {LEGACY_REDIRECTS.map(([from, to]) => (
              <Route
                key={from}
                path={from}
                element={<Navigate to={to} replace />}
              />
            ))}
          </Route>
        </Route>

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
